import { createBrowserRouter, Navigate, RouterProvider, useParams } from "react-router-dom"
import { AuthScreen } from "@/components/screens/AuthScreen"
import { HomeScreen } from "@/components/screens/HomeScreen"
import { ForgotPasswordScreen } from "@/components/screens/ForgotPasswordScreen"
import { ResetPasswordScreen } from "@/components/screens/ResetPasswordScreen"
import { ActivationShell } from "@/components/screens/ActivationShell"
import { DashboardScreen } from "@/components/screens/DashboardScreen"
import { DealPipelineScreen } from "@/components/screens/DealPipelineScreen"
import { DealDetailScreen } from "@/components/screens/DealDetailScreen"
import { CapitalPipelineScreen } from "@/components/screens/CapitalPipelineScreen"
import { SettingsScreen } from "@/components/screens/SettingsScreen"
import { AccountSettingsScreen } from "@/components/screens/AccountSettingsScreen"
import { TargetStep } from "@/components/activation/steps/TargetStep"
import { StrategyStep } from "@/components/activation/steps/StrategyStep"
import { AreaStep } from "@/components/activation/steps/AreaStep"
import { DynamicsStep } from "@/components/activation/steps/DynamicsStep"
import { CriteriaStep } from "@/components/activation/steps/CriteriaStep"
import { useSession } from "@/lib/session-context"

const STEP_COMPONENTS = { 1: TargetStep, 2: StrategyStep, 3: AreaStep, 4: DynamicsStep, 5: CriteriaStep }

function StepRoute() {
  const { n } = useParams()
  const Component = STEP_COMPONENTS[Number(n)] ?? TargetStep
  return <Component />
}

function Root() {
  const { currentUser } = useSession()
  return currentUser ? <HomeScreen /> : <Navigate to="/sign-in" replace />
}

function AuthRoute() {
  const { currentUser } = useSession()
  return currentUser ? <Navigate to="/" replace /> : <AuthScreen />
}

function VerifyTwoFactorRoute() {
  const { currentUser } = useSession()
  return currentUser ? <Navigate to="/" replace /> : <AuthScreen />
}

const router = createBrowserRouter([
  { path: "/sign-in", Component: AuthRoute },
  { path: "/sign-up", Component: AuthRoute },
  { path: "/confirmation-sent", Component: AuthRoute },
  { path: "/forgot-password", Component: ForgotPasswordScreen },
  { path: "/reset-password", Component: ResetPasswordScreen },
  { path: "/verify-2fa", Component: VerifyTwoFactorRoute },
  { path: "/dashboard", Component: DashboardScreen },
  { path: "/deal-pipeline", Component: DealPipelineScreen },
  { path: "/deal-pipeline/:dealId", Component: DealDetailScreen },
  { path: "/capital-pipeline", Component: CapitalPipelineScreen },
  { path: "/settings", Component: SettingsScreen },
  { path: "/settings/account", Component: AccountSettingsScreen },
  {
    path: "/activation",
    Component: ActivationShell,
    children: [
      { index: true, element: <Navigate to="step/1" replace /> },
      { path: "step/:n", Component: StepRoute },
    ],
  },
  { path: "/*", Component: Root },
])

export function Router() {
  return <RouterProvider router={router} />
}
